// Resources.js
import React from 'react';
import './Pages.css';

function Resources() {
  return (
    <section id="resources" className='has-fixed-header py-5 pb-0'>
    <div className='container-fluid p-0 ps-0'>
      <div className="container">
        <div className="row align-items-star ">
          <div className="col-md-12 col-sm-12">
              <div className='content-section'>
              <h1 className="display-6 text-primary">Resources</h1>
                <p className="col-md-12 col-sm-12 mx-auto lead text-black">
                Explore our collection of resources designed to help you navigate the complexities of risk adjustment, healthcare regulations, and industry best practices.
                </p>
              </div>
          </div>
        </div>



        <div className="row g-4 border-bottom pb-5">
        <div className="col-md-4">
          <div className="card p-4 shadow-sm h-100">
            <div className="card-body text-center">
              <h4 className="text-primary text-center">Guides & eBooks</h4>
              <p className="card-text text-center">
                Download in-depth guides and eBooks on risk adjustment, compliance, and healthcare innovations.
              </p>
              <a href="#" className="btn btn-primary btn-sm px-3">Explore Guides</a>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card p-4 shadow-sm h-100">
            <div className="card-body text-center">
              <h4 className="text-primary text-center">Case Studies</h4>
              <p className="card-text text-center">
                Learn how Elevate has helped healthcare organizations achieve their goals through real-world success stories.
              </p>
              <a href="#" className="btn btn-primary btn-sm px-3">View Case Studies</a>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card p-4 shadow-sm h-100">
            <div className="card-body text-center">
              <h4 className="text-primary text-center">Webinars</h4>
              <p className="card-text text-center">
              Watch on-demand webinars featuring industry experts sharing insights on the latest trends and strategies.
              </p>

              <a href="#" className="btn btn-primary btn-sm px-3">Watch Webinars</a>
            </div>
          </div>
        </div>
      </div>


      {/* Latest Blog Posts */}
      <div className="row mt-5">
        <div className="col text-center">
          <h3 className="display-6 text-black">Latest Blog Posts</h3>
          <p className="text-black">Stay updated with expert tips, industry news, and actionable insights.</p>
        </div>
      </div>
      <div className="row g-4 mt-2 pb-5">
        <div className="col-md-6 col-sm-12">
            <h5 className="card-title fw-bold">5 Tips to Simplify Risk Adjustment</h5>
              <p className="card-text text-muted">
                Learn how to streamline your risk adjustment processes with actionable strategies.
              </p>
              <a href="#" className="btn btn-link">Read More</a>
        </div>

        <div className="col-md-6 col-sm-12">
            <h5 className="card-title fw-bold">The Future of Healthcare Analytics</h5>
              <p className="card-text text-muted">
                  Explore how advanced analytics is transforming the healthcare industry and driving better outcomes.
              </p>
              <a href="#" className="btn btn-link">Read More</a>
        </div>

        <div className="col-md-6 col-sm-12">
            <h5 className="card-title fw-bold">Navigating Healthcare Compliance</h5>
              <p className="card-text text-muted">
              Discover best practices for maintaining compliance in an ever-changing regulatory landscape.
              </p>
              <a href="#" className="btn btn-link">Read More</a>
        </div>




      </div>


    </div>


      




      



  </div>



    </section>
  );
}

export default Resources;